// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountingExportDebitorsController = function ($scope, $http) {
    $scope.exportDebitors = function (format) {
        $scope.fileLink = null;
        $http({
            method: "POST",
            url: "/api/v1/accountingexportdebitors",
            params: { format: format },
            data: {},
            headers: {},
            cache: false
        }).then(function (response) {
            $scope.fileLink = response.data;
        });
    }
};
AccountingExportDebitorsController.$inject = ['$scope', '$http'];
